import { Button, Group, Radio, Stack } from "@mantine/core";
import { useState } from "react";
import CreatableContactListSelector from "../../../../../components/Selectors/CreatableContactListSelector";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { IconCopy } from "@tabler/icons-react";
import { notifications } from "@mantine/notifications";
import { copyPrmToList } from "../../../../../api/PRMAPI";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../../stores/LeadsStore";
import { useParams } from "react-router-dom";
import { useProfileStore } from "../../../../../stores/UserStore";
import { deselectAll } from "../../utils";
import { transformFilterToServer } from "../../../../../functions/utilFunctions";

const defaults = ["opener", "clicker", "answerer", "to_call", "out_of_office"];

const LeadsCopyListDestination = ({ id, type, handleClose, onFinish, tableFilter, tableSelection }) => {
  const lang = useLanguage((s) => s.language);
  const query = useLeadsStore((s) => s.query);
  const { userId } = useParams();

  const globalFilter = useLeadsStore((s) => s.filter);
  const globalSelectedIds = useLeadsContainerStore((s) => s.selectedIds);
  const unselectedIds = useLeadsContainerStore((s) => s.unselectedIds);
  const selectedColumns = useLeadsContainerStore((s) => s.selectedColumns);
  const [value, setValue] = useState("list");
  const [list, setList] = useState(null);

  const selectedIds = tableSelection || globalSelectedIds;
  const filter = tableFilter ? transformFilterToServer(tableFilter) : globalFilter;

  const [loading, setLoading] = useState(false);

  const handleValueChange = (change) => {
    setValue(change);
    setTimeout(() => {
      document.getElementById(`${change}-selector`);
    }, 50);
  };

  const main = () => {
    let mainFilterValues = [];
    let excluded = [];
    if (selectedColumns.length > 0) {
      selectedColumns.forEach((col) => {
        if (defaults.includes(col)) {
          let v = [
            {
              field_name: "status",
              type: "equals",
              value: col,
            },
            {
              field_name: "custom_status",
              type: "equals",
              value: "null",
            },
          ];

          if (query) {
            v.push({
              field_name: "any_datafield",
              type: "contains",
              value: query,
            });
          }

          if (filter) {
            v.push(filter);
          }

          mainFilterValues.push({
            mode: "and",
            values: v,
          });
        } else {
          let v = [
            {
              field_name: "custom_status",
              type: "equals",
              value: col.toString(),
            },
          ];

          if (filter) {
            v.push(filter);
          }

          mainFilterValues.push({
            mode: "and",
            values: v,
          });
        }
        if (unselectedIds[col]) {
          excluded.push(...unselectedIds[col]);
        }
      });
    }

    let parsedFilter = {
      mode: "or",
      values: mainFilterValues,
    };

    let justFilter = {
      mode: "and",
      values: [],
    };
    if (type === "filter" && filter) {
      justFilter.values.push(filter);
    }
    if (type === "filter" && query) {
      justFilter.values.push({
        field_name: "any_datafield",
        type: "contains",
        value: query,
      });
    }

    setLoading(true);
    copyPrmToList({
      user_id: parseInt(userId) || useProfileStore.getState().profile?.id,
      contact_list_id: list?.id,
      contacts_selection: {
        contact_ids:
          type === "selection_inverse" || type === "all"
            ? []
            : Object.values(selectedIds).flatMap((x) => x),
        excluded_contact_ids:
          type === "selection_inverse"
            ? Object.values(unselectedIds).flatMap((x) => x)
            : [],
        filter: type === "filter" ? justFilter : parsedFilter,
      },
    })
      .then((res) => {
        onFinish?.(type);
        notifications.show({
          message: lang.contact_lists.content.copy_selection.success,
          color: "tertiary.8",
        });
        handleClose();

        if (type === "selection") {
          deselectAll();
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Stack w={300}>
      <Radio.Group value={value} onChange={handleValueChange} name="value">
        <Stack gap={4} mt={"sm"}>
          <CreatableContactListSelector
            setValue={setList}
            value={list}
            disabled={value !== "list"}
            id={"list-selector"}
            autoFocus={true}
          />
        </Stack>
      </Radio.Group>
      <Group justify="end">
        <Button
          leftSection={<IconCopy size={16} />}
          onClick={main}
          loading={loading}
          disabled={!list}
        >
          {lang.contact_lists.copy_to_user.dialog.submit_button}
        </Button>
      </Group>
    </Stack>
  );
};

export default LeadsCopyListDestination;
